import { render, staticRenderFns } from "./ShippingAddressCard.vue?vue&type=template&id=6743c462&lang=pug"
import script from "./ShippingAddressCard.vue?vue&type=script&lang=js"
export * from "./ShippingAddressCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports